// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.embla-buttons-box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.25rem;
}
@media screen and (max-width: 991.98px) {
  .embla-buttons-box {
    gap: 1rem;
  }
}
@media screen and (max-width: 767.98px) {
  .embla-buttons-box {
    gap: 0.75rem;
  }
}

.embla__button {
  width: 3.125rem;
  min-width: 3.125rem;
  height: 3.125rem;
  background-color: var(--primaryMain-1000);
  border: 0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 200ms all ease-in-out;
}
.embla__button svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--white-1000);
}
.embla__button:hover:not(:disabled) {
  transform: scale(0.95);
}
.embla__button:active:not(:disabled) {
  transform: scale(0.85);
}
.embla__button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media screen and (max-width: 991.98px) {
  .embla__button {
    width: 2rem;
    min-width: 2rem;
    height: 2rem;
  }
  .embla__button svg {
    width: 0.75rem;
    height: 0.75rem;
  }
}
@media screen and (max-width: 767.98px) {
  .embla__button {
    width: 1.75rem;
    min-width: 1.75rem;
    height: 1.75rem;
  }
  .embla__button svg {
    width: 0.625rem;
    height: 0.625rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common_UI_Kit/EmblaArrowButtons/EmblaArrowButtonsStyle.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACF;AACE;EANF;IAOI,SAAA;EAEF;AACF;AAAE;EAVF;IAWI,YAAA;EAGF;AACF;;AAAA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;AAGF;AADE;EACE,cAAA;EACA,eAAA;EACA,uBAAA;AAGJ;AAAE;EACE,sBAAA;AAEJ;AACE;EACE,sBAAA;AACJ;AAEE;EACE,YAAA;EACA,mBAAA;AAAJ;AAGE;EAhCF;IAiCI,WAAA;IACA,eAAA;IACA,YAAA;EAAF;EAEE;IACE,cAAA;IACA,eAAA;EAAJ;AACF;AAGE;EA3CF;IA4CI,cAAA;IACA,kBAAA;IACA,eAAA;EAAF;EAEE;IACE,eAAA;IACA,gBAAA;EAAJ;AACF","sourcesContent":[".embla-buttons-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1.25rem;\n\n  @media screen and (max-width: 991.98px) {\n    gap: 1rem;\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    gap: 0.75rem;\n  }\n}\n\n.embla__button {\n  width: 3.125rem;\n  min-width: 3.125rem;\n  height: 3.125rem;\n  background-color: var(--primaryMain-1000);\n  border: 0;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: 200ms all ease-in-out;\n\n  svg {\n    width: 1.25rem;\n    height: 1.25rem;\n    fill: var(--white-1000);\n  }\n  \n  &:hover:not(:disabled) {\n    transform: scale(0.95);\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.85);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  @media screen and (max-width: 991.98px) {\n    width: 2rem;\n    min-width: 2rem;\n    height: 2rem;\n\n    svg {\n      width: 0.75rem;\n      height: 0.75rem;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    width: 1.75rem;\n    min-width: 1.75rem;\n    height: 1.75rem;\n\n    svg {\n      width: 0.625rem;\n      height: 0.625rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
